module.exports = __webpack_public_path__ + "img/circle.ced1630c.svg";